<template>
  <div>
    <right-panel class="float-right" id="sidebar-new-asset-group-category" width="600px" icon="" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form @onAdminChanged="onAdminChanged" @onAssetGroupCategorySaved="onAdminChanged" />
      </div>
    </right-panel>

    <div class="ds-card">
      <div class="ds-card--title ">
        <div class="d-flex">
          <div class="">
            <span>
              <i class="iconoir-center-align align-middle mr-3 mt-2" style="color: #383A55; font-size: 1.5rem !important;"></i>
              {{ $t("asset-group-category.organization") }}
            </span>
          </div>
          <div class="">
            <div class="search2 ml-4 mb-4" style=" width: 18.50rem;">
              <div class="search2--icon"><i class="iconoir-search"></i></div>
              <input class="search2--input" type="text" :placeholder="$t('asset-group-category.search')" v-model="nameFilter" />
            </div>
          </div>
        </div>
        <div class="d-flex ml-auto mb-2">
          <div v-if="recommendationAvailable" class=" d-flex mr-auto">
            <label class="switch-label">{{ $t("common.recommendations") }}</label>
            <b-form-checkbox v-model="showRecommendationBoxes" name="check-button" switch class="switch"></b-form-checkbox>
          </div>
        </div>
      </div>

      <content-loading v-if="isLoading" />

      <div v-else-if="pagination">
        <div class="d-flex" style="gap: 1.25rem;flex-wrap: wrap;">
          <div v-for="item in pagination.docs" :key="item._id" :id="'popover-target-' + item._id" class="ds-card--item" :class="selectedBoxStyle(item)" @click="selectBox(item)">
            <div class="text">{{ item.name | translate }}</div>
            <div class="actions d-flex justify-content-center">
              <div class="action" v-if="hasRemovePermission" @click="deleteById(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.delete')">
                <i class="iconoir-trash"></i>
              </div>
              <!-- <div class="action" v-if="hasUpdatePermission" @click="markAsComplete(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.completed')">
              <i :class="item.completed ? 'iconoir-check-circle' : 'iconoir-circle'"></i>
            </div> -->
              <div class="action" @click="edit(item)" v-on:click.stop v-b-toggle="'sidebar-edit-organization-department'" v-b-tooltip.hover :title="$t('common.edit')">
                <i class="iconoir-edit-pencil"></i>
              </div>
              <!-- <div class="action" @click="showInventoryPanel(item)" v-on:click.stop v-b-tooltip.hover :title="$t('inventory.filter.inventory-features')">
              <i class="iconoir-network-right"></i>
            </div> -->
            </div>

            <b-popover :target="'popover-target-' + item._id" triggers="hover" placement="bottom" variant="secondary">
              <template #title> {{ $t("asset-group-category.admin") }}</template>
              <table>
                <tr v-for="admin in item.admins" :key="'asset-group-category-admin' + admin._id">
                  <td><letter-avatar :name="admin.account.name" :image="admin.account.avatar" variant="secondary" /></td>
                  <td class="text-center">{{ admin.account.name }}</td>
                </tr>
                <tr v-if="!item.admins || item.admins.length < 1">
                  <span>
                    <b>
                      {{ $t("asset-group-category.no-admin") }}
                    </b>
                  </span>
                </tr>
              </table>
            </b-popover>
          </div>

          <div class="ds-card--item2" v-b-toggle="'sidebar-new-asset-group-category'">
            <i class="iconoir-plus" style="font-size: 1.75rem;"></i>
          </div>
        </div>
      </div>

      <!-- Begin: Pagination -->

      <div v-if="pagination" class="row mt-4">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->
      <recommendation-boxes
        :show="showRecommendationBoxes"
        :query="{ products: { value: currentProduct, isObject: true } }"
        level="assetGroupCategory"
        :libraryScopedState="libraryScopedState"
        organizationScopedState="organizationAssetGroupCategory"
        :title="$t('asset-group-category.recommendations')"
        @onAccepted="paginate"
        @copyToForm="copyToForm"
      />
    </div>
  </div>
</template>

<script>
import RecommendationBoxes from "../../entity/component/recommendation-boxes";
import Form from "../organization-asset-group-category-form";

export default {
  components: { Form, RecommendationBoxes },
  props: ["product"],
  data() {
    return {
      request: {
        options: { page: 1, limit: 17, sort: { name: "asc" } },
        query: {},
      },

      libraryScopedState: "assetGroupCategory",
      showRecommendationBoxes: undefined,
      nameFilter: undefined,
    };
  },
  computed: {
    recommendationAvailable() {
      const loading = this.$store.getters[`${this.libraryScopedState}/isLoading`];
      const recommendations = this.$store.getters[`${this.libraryScopedState}/recommendations`];

      if (loading) {
        return false;
      }
      if (recommendations && recommendations.docs && recommendations.docs.length > 0) {
        return true;
      }
      return false;
    },
    pagination() {
      return this.$store.getters["organizationAssetGroupCategory/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationAssetGroupCategory/isLoading"];
    },

    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },
    selectedBox() {
      return this.$store.getters["assetGroupBoxes/assetGroupCategory"];
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    async nameFilter(n, o) {
      this.debounce(() => this.handleNameFilterChanged(n, o));
    },
  },
  mounted() {},
  methods: {
    async handleNameFilterChanged(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };

        const selectedAssetGroupCategory = this.$store.getters["assetGroupBoxes/assetGroupCategory"];
        if (selectedAssetGroupCategory) {
          await this.selectBox(selectedAssetGroupCategory);
        }
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    selectedBoxStyle(item) {
      let style = "";
      if (this.selectedBox?._id == item._id) {
        style = "bg-main text-white";
      } else if (item.completed) {
        style += " completed";
      }
      return style;
    },

    async paginate() {
      const payload = { ...this.request };

      if (this.product) {
        payload.query = { ...this.request.query, products: { value: this.product, isObject: true } };
      }

      await this.$store.dispatch("organizationAssetGroupCategory/paginate", payload);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationAssetGroupCategory/delete", item._id);
        this.paginate();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },
    copyToForm(item) {
      this.$store.commit(`organizationAssetGroupCategory/copingEntity`, { ...item, libraryItem: item, _id: undefined });
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-organization-asset-group-category");
    },
    edit(item) {
      this.$store.commit("organizationAssetGroupCategory/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-asset-group-category");
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.commit("organizationAssetGroupCategory/editedEntity");
      this.$store.commit("organizationAssetGroupCategory/copingEntity");
      // this.$store.dispatch("organizationAssetGroupCategory/resetForm");
    },

    async selectBox(item) {
      return this.$store.dispatch("assetGroupBoxes/selectAssetGroupCategory", item);
    },

    async onAdminChanged() {
      const selectedAssetGroupCategory = this.$store.getters["assetGroupBoxes/assetGroupCategory"];

      await this.selectBox(selectedAssetGroupCategory); //ikikere çağırılmasının nedeni toggle yapmak
      await this.selectBox(selectedAssetGroupCategory);
    },
    copyToForm(item) {
      this.$store.commit(`organizationAssetGroupCategory/copingEntity`, { ...item, libraryItem: item, _id: undefined });
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-asset-group-category");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../entity/organization-entities-view.scss");
</style>
